import { cx } from "./cx";

/** 变化量单元格（设计系统 Table 的 ax-delta）：带 ▲▼ 与颜色，text 是已经格式化好的绝对值（"13.5%"、"0.3pp"）。
 * direction 为 0 或没有可比的基数（text 为空）时显示"—"不加色；方向的好坏由页面判断，good 为假时上升显示为 down 色。 */
export function Delta({ direction, text, good = true }: { direction: number; text?: string; good?: boolean }) {
  if (!text) return <span className="ax-delta">—</span>;
  const up = direction > 0;
  const tone = direction === 0 ? undefined : up === good ? "up" : "down";
  return <span className={cx("ax-delta", tone)}>{direction === 0 ? "" : up ? "▲ " : "▼ "}{text}</span>;
}
